/**
 * Quest lines: when a quest becomes claimable, the Mystic names it in the
 * chat, once. The quest board is the path; nothing else lists it.
 */

/** The moments that earn the Quest badge's shake and chime. Everything else
 *  is one quiet line from the Mystic: a practice, not a slot machine. */
export const BIG_MOMENTS = new Set(['profile_signs', 'profile_avatar', 'send_care_package'])

function allQuests (quests) {
  if (!quests) return []
  return [...(quests.daily || []), ...((quests.columns || []).flatMap((c) => c.quests || []))]
}

/** Quests that became claimable since `seen` (a Set of keys already claimable). */
export function newlyClaimable (seen, quests) {
  return allQuests(quests).filter((q) => q.claimable && !seen.has(q.key))
}

/** The keys claimable right now: the baseline for the next look. */
export function claimableKeys (quests) {
  return new Set(allQuests(quests).filter((q) => q.claimable).map((q) => q.key))
}

/** The Mystic's one line for what was just earned (several quests, one line). */
export function questLine (fresh) {
  const total = fresh.reduce((n, q) => n + (q.payout || 0), 0)
  return `✦ ${fresh.map((q) => q.title).join(' · ')}: ${total} carats are waiting for you in Quest.`
}
